
export const groupSections = (sections) => ({
    valid: !sections.find((s) => !s?.valid),
    highlightErrors: () => sections.find((s) => s && !s.valid && s.highlightErrors)?.highlightErrors(),
    handleApiError: (error) => sections.forEach((s) => s?.handleApiError?.(error)),
    clearApiError: () => sections.forEach((s) => s?.clearApiError?.()),
});